import { TenantFilterValues } from "./tenants-filter.types";

export const getTenantsFilterStrippedValues = (values: TenantFilterValues) => {
  return Object.keys(values).reduce((acc, key) => {
    const value = values[key];
    if (value?.length || typeof value === "boolean") {
      return { ...acc, [key]: value };
    }
    return acc;
  }, {});
};
